<template>
    <div class="client-step" data-cy="reserve_step_clients">
        <div class="client-step__hero">
            <div class="client-step__content">
                <span class="client-step__eyebrow">Etapa 1</span>
                <h4 class="client-step__title">Informar ou cadastrar um cliente</h4>
                <p class="client-step__description">
                    Comece pelo CPF. Vamos consultar a base e, na sequencia, voce podera selecionar ou cadastrar o
                    cliente.
                </p>

                <div class="client-step__search" :class="{'client-step__search--focus': taxpayerSearch}">
                    <div class="client-step__icon">
                        <i class="icon-search"></i>
                    </div>
                    <input type="text"
                           id="taxpayer"
                           name="taxpayer"
                           v-model="taxpayerSearch"
                           v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                           inputmode="numeric"
                           placeholder="Digite o CPF ou CNPJ do cliente"
                           data-cy="reserve_step_client_taxpayer"
                           ondrop="return false"
                           @keyup="onTaxpayerInput"
                           @keyup.enter="searchClient">
                    <button class="client-step__search-button"
                            type="button"
                            :disabled="isSearchingClient"
                            data-cy="reserve_step_client_search"
                            @click.stop.prevent="searchClient">
                        {{ isSearchingClient ? 'Buscando...' : 'Localizar' }}
                    </button>
                </div>

                <div v-if="taxpayerError" class="client-step__field-error">
                    {{ taxpayerError }}
                </div>
                <div v-if="clientSearchMessage" class="client-step__message" :class="clientSearchMessageClass">
                    {{ clientSearchMessage }}
                </div>
            </div>

            <div class="client-step__counter" data-cy="reserve_step_clients_total">
                <span class="client-step__counter-number">{{ clients.length }}</span>
                <span class="client-step__counter-label">cliente(s)<br>adicionado(s)</span>
            </div>
        </div>

        <div class="mt-2" v-if="clientSearchStatus === 'found'">
            <section class="client-step__result-card client-step__result-card--found">
                <div class="client-step__section-heading">
                    <span class="client-step__status-dot"></span>
                    <span>Cliente localizado e adicionado a reserva</span>
                </div>

                <div class="client-step__person-card">
                    <div class="client-step__avatar"
                         :class="getAvatarClass(this.clients?.length >= 1 ? (this.clients?.length - 1) : 0)">
                        {{ getIconName(client.name) }}
                    </div>
                    <div class="client-step__person-info">
                        <h5>{{ client.name }}</h5>
                        <p>{{ client.taxpayer }}</p>
                        <div class="client-step__chips">
                            <span>Cliente ativo</span>
                            <span>Cadastro completo</span>
                        </div>
                    </div>
                </div>

                <div class="client-step__details">
                    <div>
                        <small>Telefone</small>
                        <strong>(62) 99999-0000</strong>
                    </div>
                    <div>
                        <small>E-mail</small>
                        <strong>{{ this.client.email }}</strong>
                    </div>
                    <div>
                        <small>Origem</small>
                        <strong>Base de clientes</strong>
                    </div>
                </div>
            </section>
        </div>
        <div class="mt-2" v-if="clientSearchStatus === 'new'">
            <section class="client-step__result-card client-step__result-card--create">
                <div class="client-step__section-heading">
                    <span class="client-step__status-dot client-step__status-dot--muted"></span>
                    <span>CPF nao encontrado</span>
                </div>

                <div class="client-step__create-header">
                    <h5>Cadastrar novo cliente</h5>
                    <p>Preencha apenas os dados essenciais para adicionar o cliente a esta reserva.</p>
                </div>

                <div class="client-step__form-grid">
                    <div class="client-step__field">
                        <label>CPF/CNPJ</label>
                        <input type="text" value="" placeholder="Ex.: 000.000.000-00" v-model="clientNew.taxpayer">
                    </div>
                    <div class="client-step__field">
                        <label>Nome completo</label>
                        <input type="text" value="" placeholder="Ex.: Carlos Henrique Lima" v-model="clientNew.name">
                    </div>
                    <div class="client-step__field">
                        <label>Telefone</label>
                        <input type="text" value="" placeholder="(00) 00000-0000" v-model="clientNew.phone">
                    </div>
                    <div class="client-step__field">
                        <label>E-mail</label>
                        <input type="text" value="" placeholder="cliente@email.com" v-model="clientNew.email">
                    </div>
                </div>

                <div class="client-step__create-footer">
                    <span>O cadastro completo pode ser revisado nas proximas etapas.</span>
                    <button class="client-step__ghost-button" type="button" @click="createClient()">Cadastrar e
                        adicionar
                    </button>
                </div>
            </section>
        </div>
        <section class="client-step__selected-list" v-if="clients.length">
            <div class="client-step__selected-header">
                <div>
                    <span class="client-step__eyebrow">Selecionados</span>
                    <h5>Clientes adicionados a reserva</h5>
                </div>
                <span class="client-step__selected-count">{{ clients.length }} clientes</span>
            </div>

            <div class="client-step__selected-items mb-1" v-for="(client, key) in clients"
                 :key="client.id || client.taxpayer || key">
                <article class="client-step__selected-card">
                    <div class="client-step__selected-avatar" :class="getAvatarClass(key)">{{
                            getIconName(client.name)
                        }}
                    </div>
                    <div class="client-step__selected-info">
                        <h6>{{ client.name }}</h6>
                        <span>{{ client.taxpayer }}</span>
                    </div>
                    <div class="client-step__selected-meta">
                        <small>Telefone</small>
                        <strong>(62) 99999-0000</strong>
                    </div>
                    <div class="client-step__selected-meta">
                        <small>E-mail</small>
                        <strong>{{ client.email }}</strong>
                    </div>
                    <button class="client-step__remove-button" type="button" title="Remover cliente"
                            @click="removeClient(key)">
                        <i class="icon-trash"></i>
                    </button>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';
import {mapActions} from 'vuex';
import {normalizeTaxpayer, validateCnpj, validateCpf} from '@/Helpers/Taxpayer';

export default {
    name: 'ReserveStepClients',
    setup() {
        const {t} = useI18n();
        const toast = useToast();

        return {t, toast};
    },
    data() {
        return {
            client: {},
            clients: [],
            clientsIds: [],
            isSearchingClient: false,
            clientSearchMessage: '',
            clientSearchStatus: null,
            taxpayerSearch: null,
            isEmailNull: false,
            taxpayerError: '',
            clientNew: {},
            avatarClasses: [
                '',
                'client-step__selected-avatar--blue',
                'client-step__selected-avatar--gold',
                'client-step__selected-avatar--purple',
                'client-step__selected-avatar--rose',
                'client-step__selected-avatar--slate',
            ],
        };
    },
    computed: {
        clientSearchMessageClass() {
            return {
                'client-step__message--success': this.clientSearchStatus === 'found',
                'client-step__message--warning': this.clientSearchStatus === 'new',
                'client-step__message--error': this.clientSearchStatus === 'error',
            };
        },
    },
    methods: {
        ...mapActions({
            showByTaxpayerAction: 'showByTaxpayer',
            createClientAction: 'createClientAction',
        }),
        clearClient() {
            this.client = {};
            this.clientNew = {};
            this.isSearchingClient = false;
            this.clientSearchMessage = '';
            this.clientSearchStatus = null;
            this.taxpayerSearch = null;
        },
        removeClient(key) {
            this.clearClient();
            this.clients = this.clients.filter((i, k) => k !== key);
        },
        formatNewClient() {
            return {
                taxpayer: this.clientNew.taxpayer,
                name: this.clientNew.name,
                email: this.clientNew.email,
                allotment_id: sessionStorage.getItem('allotmentIdScope'),
                phones: [
                    {
                        type: 1,
                        number: this.client.phone,
                        description: null,
                        code_country: 55,
                        country_acronym: "BR",
                    }
                ],
                simpleInsert: true,
            };
        },
        createClient() {
            let data = this.formatNewClient();
            this.$store.commit('changeLoading', true);
            this.createClientAction(data).then(resp => {
                if (resp.data.id) {
                    this.toast.success('Cliente Cadastrado com sucesso!');
                    this.clientNew = {};
                    this.clients.push(resp.data);
                    this.onTaxpayerInput();
                }
            }).catch((err) => {
                this.errorMsg(err);
            }).finally(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        getIconName(name) {
            if (!name) {
                return '-';
            }
            return name?.slice(0, 2)?.toUpperCase();
        },
        getAvatarClass(index) {
            return this.avatarClasses[index % this.avatarClasses.length];
        },
        getEmptyClient(taxpayer = null) {
            return {
                taxpayer,
                name: null,
                email: null,
                phones: [{
                    type: 1,
                    number: '',
                    description: null,
                    code_country: 55,
                    country_acronym: 'BR',
                }],
            };
        },
        onTaxpayerInput() {
            this.clientSearchMessage = '';
            this.clientSearchStatus = null;
            this.taxpayerError = '';
        },
        ensureClientPhone(client) {
            if (!client.phones?.length) {
                client.phones = this.getEmptyClient().phones;
            }

            return client;
        },
        validateTaxpayer() {
            const taxpayer = this.taxpayerSearch;
            const normalized = normalizeTaxpayer(taxpayer);
            if (!taxpayer) {
                this.taxpayerError = 'Informe o CPF ou CNPJ para localizar o cliente.';
                return false;
            }
            if (this.clients?.find(i => i.taxpayer === this.taxpayerSearch)) {
                this.taxpayerError = 'Cliente já esta adicionado a reserva';
                return false;
            }
            if (normalized.length === 11 && this.validateCpf(taxpayer)) {
                this.taxpayerError = '';
                return true;
            }
            if (normalized.length === 14 && this.validateCnpj(taxpayer)) {
                this.taxpayerError = '';
                return true;
            }
            if (![11, 14].includes(normalized.length)) {
                this.taxpayerError = 'Informe um CPF ou CNPJ completo.';
                return false;
            }
            this.taxpayerError = 'CPF/CNPJ invalido. Confira os numeros digitados.';
            return false;
        },
        validateCpf(taxpayer) {
            return validateCpf(taxpayer);
        },
        validateCnpj(taxpayer) {
            return validateCnpj(taxpayer);
        },
        async searchClient() {
            if (!this.validateTaxpayer()) return;
            this.isSearchingClient = true;
            this.clientSearchMessage = '';
            this.clientSearchStatus = null;
            this.$store.commit('changeLoading', true);
            const tax = btoa(this.taxpayerSearch);
            try {
                const resp = await this.showByTaxpayerAction(tax);
                if (resp.data?.id) {
                    const locatedClient = this.ensureClientPhone(resp.data);
                    this.isEmailNull = !locatedClient.email;
                    if (String(locatedClient.company_id) !== String(localStorage.getItem('companyId'))) {
                        locatedClient.id = null;
                    }
                    this.client = locatedClient;
                    this.clientSearchStatus = 'found';
                    this.clientSearchMessage = this.t('GENERAL.MSG.CLIENT_LOCATED_IN_THE_DATABASE');
                    this.clients.push(this.client);
                    this.taxpayerSearch = null;
                } else {
                    this.client = {};
                    this.clientNew = this.getEmptyClient(this.taxpayerSearch);
                    this.taxpayerSearch = null;
                    this.clientSearchStatus = 'new';
                    this.clientSearchMessage = 'Cliente nao localizado. Preencha os dados para cadastrar e adicionar a reserva.';
                }
            } catch (error) {
                this.clientSearchStatus = 'error';
                this.clientSearchMessage = 'Nao foi possivel consultar o cliente.';
                this.toast.error(this.clientSearchMessage);
            } finally {
                this.isSearchingClient = false;
                this.$store.commit('changeLoading', false);
            }
        },
    },
};
</script>

<style scoped>
.client-step__hero {
    align-items: stretch;
    background: radial-gradient(circle at 10% 15%, rgba(14, 94, 78, .16), transparent 28%),
    linear-gradient(135deg, #f8fbfa 0%, #eef5f3 48%, #ffffff 100%);
    border: 1px solid #dce8e5;
    border-radius: 20px;
    box-shadow: 0 14px 34px rgba(39, 52, 63, .07);
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(0, 1fr) 145px;
    overflow: hidden;
    padding: 1.15rem 1.25rem;
    position: relative;
}

.client-step__hero:before {
    background: linear-gradient(180deg, rgba(14, 94, 78, .35), rgba(14, 94, 78, 0));
    border-radius: 999px;
    content: "";
    height: 170px;
    position: absolute;
    right: -70px;
    top: -90px;
    transform: rotate(32deg);
    width: 170px;
}

.client-step__content {
    position: relative;
    z-index: 1;
}

.client-step__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: .66rem;
    font-weight: 800;
    letter-spacing: .1rem;
    margin-bottom: .38rem;
    text-transform: uppercase;
}

.client-step__title {
    color: #27343f;
    font-size: 1.22rem;
    font-weight: 800;
    letter-spacing: -.02rem;
    line-height: 1.15;
    margin-bottom: .32rem;
}

.client-step__description {
    color: #68747f;
    font-size: .84rem;
    line-height: 1.42;
    margin-bottom: .9rem;
    max-width: 620px;
}

.client-step__search {
    align-items: center;
    background: rgba(255, 255, 255, .92);
    border: 1px solid #d8e5e2;
    border-radius: 15px;
    box-shadow: 0 10px 24px rgba(39, 52, 63, .06);
    display: flex;
    gap: .55rem;
    max-width: 680px;
    padding: .42rem .42rem .42rem .62rem;
    transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.client-step__search--focus,
.client-step__search:focus-within {
    border-color: #0e5e4e;
    box-shadow: 0 16px 38px rgba(14, 94, 78, .14);
    transform: translateY(-1px);
}

.client-step__icon {
    align-items: center;
    background: #e7f2ef;
    border-radius: 12px;
    color: #0e5e4e;
    display: flex;
    flex: 0 0 36px;
    height: 36px;
    justify-content: center;
}

.client-step__search input {
    background: transparent;
    border: 0;
    color: #27343f;
    flex: 1;
    font-size: .9rem;
    font-weight: 600;
    min-width: 0;
    outline: none;
}

.client-step__search input::placeholder {
    color: #9aa6af;
    font-weight: 500;
}

.client-step__search-button {
    background: linear-gradient(135deg, #0e5e4e, #128a72);
    border: 0;
    border-radius: 12px;
    box-shadow: 0 8px 18px rgba(14, 94, 78, .2);
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    min-height: 36px;
    padding: 0 1rem;
    transition: filter .2s ease, transform .2s ease;
}

.client-step__search-button:hover:not(:disabled) {
    filter: brightness(1.04);
    transform: translateY(-1px);
}

.client-step__search-button:disabled {
    cursor: not-allowed;
    opacity: .72;
}

.client-step__message {
    border-radius: 12px;
    font-size: .8rem;
    font-weight: 700;
    margin-top: .7rem;
    max-width: 680px;
    padding: .65rem .8rem;
}

.client-step__message--success {
    background: #e7f5ef;
    color: #0e5e4e;
}

.client-step__message--warning {
    background: #fff6df;
    color: #8a6200;
}

.client-step__message--error {
    background: #fde8e8;
    color: #a23434;
}

.client-step__field-error {
    background: #fff1f1;
    border: 1px solid #ffd3d3;
    border-radius: 12px;
    color: #a23434;
    display: inline-flex;
    font-size: .82rem;
    font-weight: 800;
    margin-top: .75rem;
    padding: .55rem .75rem;
}

.client-step__counter {
    align-items: center;
    align-self: stretch;
    background: rgba(255, 255, 255, .72);
    border: 1px solid rgba(14, 94, 78, .13);
    border-radius: 18px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .65);
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 125px;
    padding: .75rem;
    position: relative;
    text-align: center;
    z-index: 1;
}

.client-step__counter-number {
    color: #0e5e4e;
    font-size: 2.55rem;
    font-weight: 900;
    letter-spacing: -.12rem;
    line-height: .9;
}

.client-step__counter-label {
    color: #66737e;
    font-size: .68rem;
    font-weight: 800;
    letter-spacing: .04rem;
    line-height: 1.35;
    margin-top: .45rem;
    text-transform: uppercase;
}

.client-step__mock-grid {
    display: grid;
    gap: .8rem;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    margin-top: .8rem;
}

.client-step__result-card {
    background: #fff;
    border: 1px solid #e2e9ee;
    border-radius: 18px;
    box-shadow: 0 12px 28px rgba(39, 52, 63, .05);
    padding: .85rem;
}

.client-step__result-card--found {
    border-color: rgba(14, 94, 78, .22);
}

.client-step__result-card--create {
    background: linear-gradient(180deg, #fff 0%, #fbfcfd 100%);
}

.client-step__section-heading {
    align-items: center;
    color: #596673;
    display: flex;
    font-size: .68rem;
    font-weight: 900;
    gap: .42rem;
    letter-spacing: .08rem;
    margin-bottom: .72rem;
    text-transform: uppercase;
}

.client-step__status-dot {
    background: #18a77f;
    border-radius: 999px;
    box-shadow: 0 0 0 6px rgba(24, 167, 127, .12);
    display: inline-block;
    height: 9px;
    width: 9px;
}

.client-step__status-dot--muted {
    background: #d99a20;
    box-shadow: 0 0 0 6px rgba(217, 154, 32, .14);
}

.client-step__person-card {
    align-items: center;
    display: grid;
    gap: .72rem;
    grid-template-columns: 48px minmax(0, 1fr) auto;
}

.client-step__avatar {
    align-items: center;
    background: linear-gradient(135deg, #0e5e4e, #19a886);
    border-radius: 15px;
    box-shadow: 0 10px 22px rgba(14, 94, 78, .18);
    color: #fff;
    display: flex;
    font-size: .82rem;
    font-weight: 900;
    height: 48px;
    justify-content: center;
    letter-spacing: .02rem;
    width: 48px;
}

.client-step__person-info h5,
.client-step__create-header h5 {
    color: #27343f;
    font-size: .9rem;
    font-weight: 900;
    margin: 0;
}

.client-step__person-info p,
.client-step__create-header p {
    color: #75818c;
    font-size: .76rem;
    margin: .2rem 0 0;
}

.client-step__chips {
    display: flex;
    flex-wrap: wrap;
    gap: .35rem;
    margin-top: .48rem;
}

.client-step__chips span {
    background: #eef7f4;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: .64rem;
    font-weight: 800;
    padding: .25rem .48rem;
}

.client-step__add-button,
.client-step__ghost-button {
    align-items: center;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    display: inline-flex;
    font-weight: 900;
    gap: .45rem;
    min-height: 34px;
    padding: 0 .78rem;
    transition: transform .2s ease, box-shadow .2s ease;
}

.client-step__add-button {
    background: #0e5e4e;
    box-shadow: 0 10px 22px rgba(14, 94, 78, .2);
    color: #fff;
}

.client-step__ghost-button {
    background: #edf5f3;
    color: #0e5e4e;
}

.client-step__add-button:hover,
.client-step__ghost-button:hover {
    transform: translateY(-1px);
}

.client-step__details {
    border-top: 1px solid #edf1f4;
    display: grid;
    gap: .5rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-top: .82rem;
    padding-top: .78rem;
}

.client-step__details small {
    color: #8a96a1;
    display: block;
    font-size: .64rem;
    font-weight: 800;
    letter-spacing: .04rem;
    margin-bottom: .25rem;
    text-transform: uppercase;
}

.client-step__details strong {
    color: #34414d;
    display: block;
    font-size: .76rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.client-step__create-header {
    margin-bottom: .75rem;
}

.client-step__form-grid {
    display: grid;
    gap: .55rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.client-step__field--wide {
    grid-column: 1 / -1;
}

.client-step__field label {
    color: #66737e;
    display: block;
    font-size: .68rem;
    font-weight: 900;
    margin-bottom: .3rem;
}

.client-step__field input {
    background: #f7faf9;
    border: 1px solid #dfe8e6;
    border-radius: 12px;
    color: #27343f;
    min-height: 36px;
    outline: none;
    padding: 0 .7rem;
    transition: border-color .2s ease, box-shadow .2s ease;
    width: 100%;
}

.client-step__field input:focus {
    border-color: #0e5e4e;
    box-shadow: 0 0 0 4px rgba(14, 94, 78, .1);
}

.client-step__create-footer {
    align-items: center;
    display: flex;
    gap: .75rem;
    justify-content: space-between;
    margin-top: .75rem;
}

.client-step__create-footer span {
    color: #7a8792;
    font-size: .7rem;
    line-height: 1.4;
}

.client-step__selected-list {
    background: #fff;
    border: 1px solid #e2e9ee;
    border-radius: 20px;
    box-shadow: 0 14px 30px rgba(39, 52, 63, .05);
    margin-top: .8rem;
    padding: .9rem;
}

.client-step__selected-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: .75rem;
}

.client-step__selected-header .client-step__eyebrow {
    margin-bottom: .35rem;
}

.client-step__selected-header h5 {
    color: #27343f;
    font-size: .92rem;
    font-weight: 900;
    margin: 0;
}

.client-step__selected-count {
    background: #eef7f4;
    border: 1px solid rgba(14, 94, 78, .12);
    border-radius: 999px;
    color: #0e5e4e;
    font-size: .68rem;
    font-weight: 900;
    padding: .34rem .62rem;
}

.client-step__selected-items {
    display: grid;
    gap: .55rem;
}

.client-step__selected-card {
    align-items: center;
    background: linear-gradient(180deg, #fbfdfc 0%, #ffffff 100%);
    border: 1px solid #edf2f4;
    border-radius: 15px;
    display: grid;
    gap: .65rem;
    grid-template-columns: 42px minmax(160px, 1.4fr) minmax(110px, 1fr) minmax(140px, 1.2fr) 36px;
    padding: .62rem;
    transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.client-step__selected-card:hover {
    border-color: rgba(14, 94, 78, .22);
    box-shadow: 0 12px 26px rgba(39, 52, 63, .06);
    transform: translateY(-1px);
}

.client-step__selected-avatar {
    align-items: center;
    background: linear-gradient(135deg, #0e5e4e, #19a886);
    border-radius: 14px;
    color: #fff;
    display: flex;
    font-size: .7rem;
    font-weight: 900;
    height: 42px;
    justify-content: center;
    width: 42px;
}

.client-step__selected-avatar--blue {
    background: linear-gradient(135deg, #2563eb, #38bdf8);
}

.client-step__selected-avatar--gold {
    background: linear-gradient(135deg, #b7791f, #f6c85f);
}

.client-step__selected-avatar--purple {
    background: linear-gradient(135deg, #6d28d9, #a78bfa);
}

.client-step__selected-avatar--rose {
    background: linear-gradient(135deg, #be185d, #fb7185);
}

.client-step__selected-avatar--slate {
    background: linear-gradient(135deg, #334155, #94a3b8);
}

.client-step__selected-info h6 {
    color: #27343f;
    font-size: .82rem;
    font-weight: 900;
    margin: 0 0 .18rem;
}

.client-step__selected-info span,
.client-step__selected-meta small {
    color: #8a96a1;
    display: block;
    font-size: .68rem;
    font-weight: 800;
}

.client-step__selected-meta small {
    letter-spacing: .04rem;
    margin-bottom: .18rem;
    text-transform: uppercase;
}

.client-step__selected-meta strong {
    color: #34414d;
    display: block;
    font-size: .76rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.client-step__remove-button {
    align-items: center;
    background: #fff1f1;
    border: 0;
    border-radius: 12px;
    color: #bd3d3d;
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: center;
    transition: background .2s ease, transform .2s ease;
    width: 36px;
}

.client-step__remove-button:hover {
    background: #fde2e2;
    transform: translateY(-1px);
}

@media (max-width: 900px) {
    .client-step__hero {
        grid-template-columns: 1fr;
        padding: 1rem;
    }

    .client-step__counter {
        align-items: center;
        flex-direction: row;
        gap: .75rem;
        justify-content: flex-start;
        min-height: auto;
        text-align: left;
    }

    .client-step__mock-grid {
        grid-template-columns: 1fr;
    }

    .client-step__selected-card {
        grid-template-columns: 48px minmax(0, 1fr) 42px;
    }

    .client-step__selected-meta {
        grid-column: 2 / -1;
    }
}

@media (max-width: 576px) {
    .client-step__search {
        align-items: stretch;
        flex-direction: column;
        padding: .75rem;
    }

    .client-step__icon {
        display: none;
    }

    .client-step__search input {
        min-height: 42px;
        text-align: center;
    }

    .client-step__search-button {
        width: 100%;
    }

    .client-step__person-card,
    .client-step__details,
    .client-step__form-grid {
        grid-template-columns: 1fr;
    }

    .client-step__add-button,
    .client-step__ghost-button {
        justify-content: center;
        width: 100%;
    }

    .client-step__create-footer {
        align-items: stretch;
        flex-direction: column;
    }

    .client-step__selected-header {
        align-items: flex-start;
        flex-direction: column;
        gap: .75rem;
    }

    .client-step__selected-card {
        grid-template-columns: 44px minmax(0, 1fr);
    }

    .client-step__selected-meta,
    .client-step__remove-button {
        grid-column: 1 / -1;
    }

    .client-step__remove-button {
        width: 100%;
    }
}
</style>
